import React, { useEffect, useState } from "react";
import Quagga from "quagga";
import config from "../jsons/scannerConfig.json";
import { validateIsbn } from "../services/valid";
import "./styles/Style.css";

const Scanner = ({code, setCode}) => {
  let scannerAttemps = 0;

  const onDetected = (result) => {
    let code = result.codeResult.code;
    if (code.length >= 10) {
      Quagga.offDetected(onDetected);
      setCode(code);
      scannerAttemps = 0;
    } else {
      scannerAttemps++;
      // if (scannerAttemps > 5) {
      //   scannerAttemps = 0;
      // }
    }
  };
  

  const handleProcessed = (result) => {
    const drawingCtx = Quagga.canvas.ctx.overlay;
    const drawingCanvas = Quagga.canvas.dom.overlay;
    drawingCtx.font = "24px Arial";
    drawingCtx.fillStyle = "green";

    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute("width")),
          parseInt(drawingCanvas.getAttribute("height"))
        );
        result.boxes
          .filter((box) => box !== result.box)
          .forEach((box) => {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2,
            });
          });
      }
      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: "blue",
          lineWidth: 5,
        });
      }
    }
  };

  useEffect(() => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      Quagga.init(config, (err) => {
        
        if (err) {
          console.log(err, "error msg");
        }
        Quagga.start();
      }); 

      Quagga.onProcessed(handleProcessed);
      Quagga.onDetected(onDetected);

      return () => {
        Quagga.stop();
      };
    }
  }, []);

  return (
    <div
      id="interactive"
      className="viewport"
      // style={{ position: "relative", height: 380 }}
    >
      <canvas
        className="drawingBuffer"
        style={{
          position: "absolute",
          // top: "0px",
          // border: "3px solid green",
        }}
      />
    </div>
  );
};

export default Scanner;
